export default "__VITE_ASSET__veZhj8vg__"